// import React, { useRef, useState } from "react";
// import { selectUser } from "../ReduxStore/userReducer";
// import { useSelector } from "react-redux";

// const handlePrinter = (response, orderType,CardName,isOtherCustomer,percentage) => {
//  const totalamount=percentage?(parseInt(percentage)/100)*response[0]?.Total_Amount:response[0]?.Total_Amount;
//  console.log("response",response);


//  try {
//     // const qrDataObject = JSON.parse(response);
//     const itemsRows = Array.isArray(response)
//       ? response.map(item => `
//           <tr>
//             <td>${item.Item_Code}</td>
//             <td>${item.Item_Description}</td>
//             <td>${item.Quantity}</td>
//             <td>${item.Unit_Price}</td>
//             <td>${item.Amounts}</td>
//           </tr>
//         `).join("")
//       : "";


//     const printWindow = window.open("", "", "width=600,height=400");
//     // Create the print content as a single string
//     const printContent = `
//   <style>
//   @page {
//     size: A4;
//     margin: 20mm;
//   }
//   body {
//     font-family: Arial, sans-serif;
//     margin: 0;
//     padding: 0;
//   }
//   .report-container {
//     width: 100%;
//     max-width: 800px;
//     margin: auto;
//     padding: 20px;
//     border: 1px solid #ccc;
//     background: #fff;
//     box-sizing: border-box;
//   }
//   .header, .details {
//     margin-bottom: 20px;
//   }
//   .header h1 {
//     margin: 0;
//     text-align: start;
//   }
//   .header h3 {
//     margin: 20px 0 10px;
//     text-align: center;
//     font-size: 20px;
//     font-weight: bold;
//   }
//   .details1 strong {
//     color: black;
//     padding: 2px; 
//     border-radius: 3px;
//     display: block;
//     margin-bottom: 2px; 
//   }
//   .details1, .details2 p {
//     margin: 0; 
//     padding: 2px; 
//   }
//   .separator {
//     border-bottom: 1px solid #000; 
//     margin: 5px 0;               
//   }
//   .details1, .details2 {
//     padding: 15px;
//     margin: 10px;
//     background-color: #f9f9f9;
//     border-radius: 5px;
//     border: 1px solid #000;
//     min-width: 200px;
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-start;
//   }
//   .details2 h4 {
//     margin: 0 0 10px;
//     font-weight: bold;
//     color: #333;
//   }

//   .details3 {
//     border: 1px solid #000;
//     padding: 8px;
//     margin: 10px 0;
//     background-color: #e9e9e9;
//     border-radius: 5px;
//     text-align: left;
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 15px;
//   }
//   .details3 p {
//     margin: 0;
//     display: flex;
//     align-items: center;
//   }
//   .details-container {
//     display: flex;
//     justify-content: space-between;
//     gap: 20px;
//   }
//   table {
//     width: 100%;
//     border-collapse: collapse;
//     margin-top: 20px;
//   }
//   th, td {
//     border: 1px solid #000;
//     padding: 8px;
//     text-align: center;
//   }
//   th {
//     background-color: #f2f2f2;
//   }
//   .summary {
//     text-align: right;
//     margin-top: 20px;
//     font-weight: bold;
//     position: relative; /* Added */
//   }
//   .slpName {
//     text-align: left;
//     margin-top: -10px;
//     position: absolute; /* Added */
//     left: 0; /* Align to the left */
//     top: 0;  /* Align with the top */
//     font-weight: bold; /* Optional */
//     background: #fff;  /* Optional */
//     padding-right: 10px; /* Optional */
//   }
//   .footer {
//     text-align: center;
//     margin-top: 30px;
//     font-style: italic;
//   }
// </style>

// <body>
//   <div class="report-container">
//     <div class="header">
//       <h1>
//         ${isOtherCustomer
//           ? CardName
//           : response[0].CompName}
//       </h1>
//       <h3>${orderType === 'Sales Quotation' ? `Sales Quotation` : `Sales Order`}</h3>
//     </div>

//     <div class="details-container">
//       <div class="details1">
//         <strong>Bill To</strong>
//         <p>${response[0]?.BillTo}</p>
//         <div class="separator"></div>
//         <strong>Ship To</strong>
//         <p>${response[0]?.ShipTo}</p>
//       </div>

//       <div class="details2">
//         <h4>Information</h4>
//         <p><strong>Order No:</strong> ${response[0]?.Order_Number}</p>
//         <p><strong>Order Date:</strong> ${response[0]?.Order_Date}</p>
//         <p><strong>Customer No:</strong> ${response[0]?.Customer_Code}</p>
//       </div>
//     </div>

//     <div class="details3">
//       <p><strong>Payment Terms:</strong> ${response[0]?.Payment_Terms}</p>
//       <p><strong>Delivery Date:</strong> ${response[0]?.Delivery_Date}</p>
//       <p><strong>Currency:</strong> ${response[0]?.Currency}</p>
//     </div>

//     <table>
//       <thead>
//         <tr>
//           <th>Item Code</th>
//           <th>Description</th>
//           <th>Quantity</th>
//           <th>Unit Price</th>
//           <th>Amount</th>
//         </tr>
//       </thead>
//       <tbody>
//         ${itemsRows}
//       </tbody>
//     </table>

//     <div class="summary">
//       <p><strong>Total:</strong> ${response[0]?.Amounts}</p>
//       <p><strong>Tax:</strong> ${response[0]?.TaxAmount}</p>
//       <p><strong>Total Amount:</strong> ${totalamount}</p>

//       <div class="slpName">
//         <p><strong>Sales Employee:</strong> ${response[0]?.SalesEmp_Name}</p>
//       </div>
//     </div>

//     <div class="footer"></div>
//   </div>
// </body>

// `;

//     printWindow.document.write(printContent);
//     printWindow.document.close();
//     printWindow.print();
//   } catch (error) {
//     console.error("Error during print:", error);
//   }
// }

// export default handlePrinter;

import React, { useRef, useState } from "react";
import { selectUser } from "../ReduxStore/userReducer";
import { useSelector } from "react-redux";
import { parseLeadDetails } from "../sharedFiles/Helper/utils";

const handlePrinter = (response, orderType, CardName,) => {
  const hasValidDiscount = response[0]?.LeadDetails && response[0]?.Percentage;
  const discountPercentage = hasValidDiscount ? parseFloat(response[0].Percentage) : 0;
  const leadDetails = hasValidDiscount ? parseLeadDetails(response[0].LeadDetails) : null;
  try {
    let total = 0;

    const itemsRows = Array.isArray(response)
      ? response.map((item) => {
        const discountAmount = (discountPercentage / 100) * item.Unit_Price;
        
        const discountedPrice = hasValidDiscount
          ? item.Unit_Price + discountAmount
          : item.Unit_Price;
        const itemTotal = discountedPrice * item.Quantity;
        total += itemTotal;
        return `
            <tr>
              <td>${item.Item_Code}</td>
              <td>${item.Item_Description}</td>
              <td>${item.Quantity}</td>
              <td>${item.UgpName}</td>
              <td>${item.TaxCode}</td>
              <td>${discountedPrice.toFixed(2)}</td>
              <td>${itemTotal.toFixed(2)}</td>
            </tr>
          `;
      }).join("")
      : "";

    const printWindow = window.open("", "_blank", "width=800,height=600,scrollbars=no,resizable=no");
    printWindow.focus();

    const printContent = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Sales Report</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 20px;
    }
    .print-wrapper {
      border: 1px solid black;
      padding: 20px;
    }
    .header {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
      border-bottom: 1px solid black;
      padding-bottom: 10px;
    }
    h3 {
      text-align: center;
      font-size: 20px;
    }
    .info-blocks {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .block {
      border: 1px solid black;
      padding: 10px;
      width: 48%;
    }
    .block p {
      margin: 5px 0;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 10px;
    }
    table, th, td {
      border: 1px solid black;
    }
    th, td {
      padding: 8px;
      text-align: center;
    }
    tfoot td {
      font-weight: bold;
      text-align: right;
      padding: 10px;
    }
  </style>
</head>
<body onload="window.print(); window.close();">

 <div class="print-wrapper">
    <div class="header">${hasValidDiscount ? CardName : response[0].CompName}</div>
    <h3>${orderType ==='Quote'?'Quote':orderType ==='UpdateQuote'? 'Update Quote': ' Purchase Order'}</h3>
    <div class="info-blocks">
      <div class="block">
        <p><strong>Billing Address:</strong></p>
        ${hasValidDiscount
        ? (leadDetails
          && `
                  <p> ${leadDetails.CustomerName}</p>
                  <p> ${leadDetails.Phone}</p>
                  <p>${leadDetails.Address}</p>
               `)
        : `<p>${response[0].BillTo}</p>`}
        
      </div>
      <div class="block">
        <p><strong>Order Number:</strong> ${response[0].Order_Number}</p>
        <p><strong>Order Date:</strong> ${response[0].Order_Date}</p>
        <p><strong>Delivery Date:</strong> ${response[0].Delivery_Date}</p>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th>Item Code</th>
          <th>Item Name</th>
          <th>Quantity</th>
          <th>UoM Group</th>
          <th>Tax Code</th>
          <th>Unit Price</th>
          <th>Total Price</th>
        </tr>
      </thead>
      <tbody>
        ${itemsRows}
      </tbody>
    </table>

    <table>
<tfoot>
  <tr>
    <td colspan="6" style="text-align: right;">Total</td>
    <td>INR ${total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  </tr>
  <tr>
    <td colspan="6" style="text-align: right;">Tax amount</td>
    <td>INR ${response[0].TaxAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  </tr>
  <tr>
    <td colspan="6" style="text-align: right;">Total Amount</td>
    <td>INR ${(total + response[0].TaxAmount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
  </tr>
</tfoot>

    </table>
  </div>

</body>
</html>
`;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
  } catch (error) {
    console.error("Error during print:", error);
  }
};

export default handlePrinter;










